// pages/Home.jsx or any component
import React, { useState } from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import ReusableModal from './ReusableModal';

const CDIRAModals = ({ openCDIraModal, setOpenCDIraModal, content }) => (
  <ReusableModal
    open={openCDIraModal}
    onClose={content?.onClose ? content?.onClose : () => setOpenCDIraModal(false)}
    content={content}
  />
);

export default CDIRAModals;
CDIRAModals.propTypes = {
  openCDIraModal: PropTypes.bool,
  setOpenCDIraModal: PropTypes.bool,
  content: PropTypes.object,
};
